import SectionImageProperties from '../../../assets/about/about-section-3-1.png';
import ScrollInAnimationItem from '../../../components/scrollInAnimationItem/ScrollInAnimationItem';
import AboutTextBox from '../aboutTextBox/AboutTextBox';

import styles from './AboutRoyaltiesSection.module.scss';

const AboutRoyaltiesSection = ({ mainAnimationLoaded }: { mainAnimationLoaded: boolean }) => {
  return (
    <div className={styles['section']}>
      <div className={styles['content']}>
        <ScrollInAnimationItem className={styles['section-image-container']} delay="0.1s">
          <img
            alt=""
            className={styles['section-image']}
            src={mainAnimationLoaded ? SectionImageProperties : ''}
            width="815"
            height="597"
          />
          <div className={`pulse-animation ${styles['section-image-gradient']}`}></div>
        </ScrollInAnimationItem>
        <ScrollInAnimationItem className={styles['textbox-container']} delay="0.2s">
          <AboutTextBox
            dark
            className={styles['textbox']}
            caption={<b>royalties</b>}
            content={
              <>
                <p>
                  Each NFT has expandable utilities that generates royalties. 3D NFT models are used in the mobile game
                  Landlord GO, and 30% of the web2 revenue is shared with the NFT owners. Additional games and metaverse
                  projects will use the models to increase revenue streams. On top of that, NFT receive 20% of the fees
                  generated in primary and secondary markets, NFT trading royalties, NFT auctions, and NFT renting.
                </p>
              </>
            }
          />
        </ScrollInAnimationItem>
      </div>
    </div>
  );
};

export default AboutRoyaltiesSection;
